import React from 'react';
import styled from 'styled-components';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import * as materialStyle from '@mui/material/styles';

const Content = styled.div`
  padding: 0px 15px;
  text-align: justify;
  overflow: auto;
`;

const Iframe = styled.iframe`
  border: 0;
`;

const LightTooltip = materialStyle.styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{
      popper: className
    }}
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    width: '100%',
    display: 'flex',
    position: 'relative',
    top: -200
  }
}));

export default {
  Content,
  Iframe,
  LightTooltip
};
